module.exports = __webpack_public_path__ + "img/2_yamahas_in_the_parking_lot.e66ac29d.jpg";